import PropTypes from 'prop-types';
import React from 'react';

import Tree from '../../dataViews/NextTree';
import Empty from '../../utils/Empty';
import Error from '../../utils/Error';
import LoadingMask from '../../utils/LoadingMask';
import Spinner from '../../utils/Spinner';
import { dynamicTreeBodyMapper } from './mappers';

@dynamicTreeBodyMapper
export default class DynamicTreeBodyContent extends React.PureComponent {
  static propTypes = {
    items: PropTypes.array,
    error: PropTypes.object,
    loading: PropTypes.bool.isRequired,
    isSyntheticRootNodeAlwaysVisible: PropTypes.bool,
  };

  static defaultProps = {
    items: [],
    error: null,
    isSyntheticRootNodeAlwaysVisible: false,
  };

  render() {
    const {
      items,
      isSyntheticRootNodeAlwaysVisible,
      error,
      loading,
    } = this.props;

    if (error) {
      return <Error error={error} />;
    }

    const hasVisibleData = items && items.length;

    const loadingSomething = Boolean(loading);

    if (!hasVisibleData) {
      if (loadingSomething) {
        return <Spinner inline={false} />;
      }
      if (!isSyntheticRootNodeAlwaysVisible) {
        return (
          <LoadingMask active={loadingSomething}>
            <Empty />
          </LoadingMask>
        );
      }
    }

    return (
      <LoadingMask active={loadingSomething}>
        <Tree.Body models={items || []} />
      </LoadingMask>
    );
  }
}
